import React from 'react';
import PropTypes from 'prop-types';
import currencyFormatter from '@magalu/stereo-ui-utils/currencyFormatter';
import { RobberyTerms, ExtendedWarrantyTerms, ExtendedWarrantyLabel, ProtectRobberyAndTheft, PaymentsWayLabel, PaymentsWayTerms } from '../financial-services.data';
import Term from '../Term';
import { SidebarHeader } from '../financial-services.styles';
import { Sidebar } from '../../../organisms';
import { Strip } from '../../../atoms';
import { parseDescriptionValue } from '../../../utils';

const TermsSidebar = ({
  servicesSelected,
  showRobberyTerm,
  setShowRobberyTerm,
  showExtendedWarrantyTerm,
  setShowExtendedWarrantyTerm,
  showPaymentsWay,
  setShowPaymentsWay
}) => {
  const terms = [{
    id: 'robbery-theft-terms',
    show: showRobberyTerm,
    terms: RobberyTerms,
    title: 'fechar termos de roubo e furto',
    label: ProtectRobberyAndTheft,
    onClick: () => setShowRobberyTerm(false)
  }, {
    id: 'extended-warranty-terms',
    show: showExtendedWarrantyTerm,
    terms: ExtendedWarrantyTerms,
    title: 'fechar termos de garantia estendida',
    label: ExtendedWarrantyLabel,
    onClick: () => setShowExtendedWarrantyTerm(false)
  }, {
    id: 'payments-way-terms',
    show: showPaymentsWay,
    terms: PaymentsWayTerms,
    title: 'fechar formas de pagamento de serviço',
    label: PaymentsWayLabel,
    onClick: () => setShowPaymentsWay(false)
  }];
  const totalPrice = Object.values(servicesSelected).reduce((acc, selected) => {
    selected.forEach(service => {
      acc += service.price;
    });
    return acc;
  }, 0);
  const totalDescription = Object.values(servicesSelected).reduce((acc, selected) => {
    selected.forEach(service => {
      acc.push(service.description);
    });
    return acc;
  }, []);
  const totalWageCompensation = Object.values(servicesSelected).reduce((acc, selected, index) => {
    const key = Object.keys(servicesSelected)[index];
    selected.forEach(service => {
      var _service$wageCompensa, _service$wageCompensa2;

      Object.assign(acc, {
        [`${key}Amount`]: (_service$wageCompensa = service.wageCompensation) != null && _service$wageCompensa.amount ? currencyFormatter({
          value: service.wageCompensation.amount
        }) : null,
        [`${key}Percentage`]: (_service$wageCompensa2 = service.wageCompensation) != null && _service$wageCompensa2.percentage ? `${service.wageCompensation.percentage}%` : null
      });
    });
    return acc;
  }, {});
  return /*#__PURE__*/React.createElement(React.Fragment, null, terms.map(term => {
    return /*#__PURE__*/React.createElement(Sidebar, {
      fullScreen: true,
      direction: "right",
      key: term.id,
      visible: term.show,
      "data-testid": term.id
    }, /*#__PURE__*/React.createElement(SidebarHeader, {
      leftButton: {
        icon: 'back',
        title: term.title,
        iconColor: '#fefefe',
        onClick: term.onClick
      },
      label: term.label
    }), /*#__PURE__*/React.createElement(Strip, null), /*#__PURE__*/React.createElement(Term, {
      terms: term.terms,
      placeholders: {
        totalPrice: currencyFormatter({
          value: totalPrice
        }),
        description: parseDescriptionValue(totalDescription),
        extendedWarrantyAmount: totalWageCompensation.extendedWarrantyAmount,
        extendedWarrantyPercentage: totalWageCompensation.extendedWarrantyPercentage,
        certainExchangeAmount: totalWageCompensation.certainExchangeAmount,
        certainExchangePercentage: totalWageCompensation.certainExchangePercentage,
        robberyAndTheftAmount: totalWageCompensation.robberyAndTheftAmount,
        robberyAndTheftPercentage: totalWageCompensation.robberyAndTheftPercentage
      },
      p: '0 12px'
    }));
  }));
};

process.env.NODE_ENV !== "production" ? TermsSidebar.propTypes = {
  servicesSelected: PropTypes.func,
  showRobberyTerm: PropTypes.func,
  setShowRobberyTerm: PropTypes.func,
  showExtendedWarrantyTerm: PropTypes.func,
  setShowExtendedWarrantyTerm: PropTypes.func,
  showPaymentsWay: PropTypes.func,
  setShowPaymentsWay: PropTypes.func
} : void 0;
export default TermsSidebar;